<template>
  <v-card outlined>
    <v-container>
      <v-toolbar flat dense>
        <div>{{$t("deliveryMethod.deliveryAreas")}}</div>
        <v-spacer />
        <v-btn v-if="!addNewZone"  color="primary" outlined @click="addNewZone = true" :disabled="loading"><v-icon>mdi-plus</v-icon></v-btn>
      </v-toolbar>
      <country-selectors
        v-if='addNewZone'
        :countries="countries"
        :restriction="newRestriction"
        @add-restriction="addRestriction"
        @cancel="addNewZone = false"
        isNew
      >
      </country-selectors>
      <v-row v-if='!isMobile && Array.isArray(restrictions) && restrictions.length'>
        <v-col cols="5"><v-list-item-action-text class='px-2 py-0'>{{ $t('deliveryMethod.sources') }}</v-list-item-action-text></v-col>
        <v-col cols="5"><v-list-item-action-text class='px-2 py-0'>{{ $t('deliveryMethod.destinations') }}</v-list-item-action-text></v-col>
        <v-col cols="12 pt-0 pb-0"><v-divider></v-divider></v-col>
      </v-row>
      <country-selectors
        v-for="restriction in restrictions"
        :countries="countries"
        :restriction="restriction"
        @remove-restriction='removeRestriction'
        :key="restriction.id">
      </country-selectors>
    </v-container>
  </v-card>
</template>

<script>
  import countries from '@/data/countries.json'
  import isoCountries from 'i18n-iso-countries'
  import countrySelectors from '@/components/carriers/deliveryMethods/eligibility/CountriesEligibilitySelectors'

  export default {
    name: "countriesEligibility",
    components: {
      countrySelectors,
    },
    props: {
      restrictions: {
        type: Array,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        newRestriction: {
          sources: [],
          destinations: [],
        },
        countries: [],
        addNewZone: false
      }
    },
    mounted() {
      isoCountries.registerLocale(require(`i18n-iso-countries/langs/${this.$i18n.locale}.json`))
      this.countries = countries.map((country) => {
        let localeCountry = {name: '', value: country.iso_3_code}
        localeCountry.name = isoCountries.getName(country.iso_3_code, this.$i18n.locale).toUpperCase()
        return localeCountry
      })
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.width <= 600
      },
    },
    methods: {
      addRestriction() {
        this.$emit('add-countries-restriction', this.newRestriction)
        this.addNewZone = false
        this.newRestriction.sources = []
        this.newRestriction.destinations = []
      },
      removeRestriction(restriction) {
        this.$emit('remove-countries-restriction', restriction)
      }
    }
  }
</script>

